import React, { useState } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { IoIosArrowDown, IoIosNotificationsOutline, IoIosLogOut, IoIosPerson, IoIosKey } from "react-icons/io";
import { CiMenuFries } from "react-icons/ci";
import { useNavigate } from 'react-router-dom';
import { IoMdClose } from "react-icons/io";

import './Header.scss';
function Header({ onToggleSidebar,isOpen }) {
  const [isProfileOpen, setIsProfileOpen] = useState(false);
  const [isNotificationOpen, setIsNotificationOpen] = useState(false);
  const admin = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogout = () => {
    navigate('/login');
  };

  const handleProfileClick = (path) => {
    setIsProfileOpen(false);
    navigate(path);
  };

  // Sample notifications data
  const notifications = [
    { id: 1, message: "New user registered", time: "5 min ago", read: false },
    { id: 2, message: "Payment received", time: "1 hour ago", read: false },
    { id: 3, message: "System update completed", time: "2 hours ago", read: true },
    { id: 4, message: "New comment on your post", time: "1 day ago", read: true },
  ];

  const unreadCount = notifications.filter(n => !n.read).length;

  return (
    <div className='header' id='header'>
      <div className="d-flex justify-content-between align-items-center w-100">
        {/* Left Side - Toggle Button */}
       {isOpen ? (
  <div className="closebutton" onClick={onToggleSidebar}>
    <IoMdClose size={24} />
  </div>
) : (
  <div className="togglebutton" onClick={onToggleSidebar}>
    <CiMenuFries size={24} />
  </div>
)}
        {/* Right Side - Links and Actions */}
        <div className="linksmode d-flex align-items-center gap-3">


          {/* Notification Dropdown */}
          <div className="notification position-relative">
            <div
              className="notification-icon position-relative cursor-pointer"
              onClick={() => setIsNotificationOpen(!isNotificationOpen)}
              style={{ cursor: 'pointer' }}
            >
              <IoIosNotificationsOutline size={24} />
              {unreadCount > 0 && (
                <span className="notification-badge">
                  {unreadCount}
                </span>
              )}
            </div>

            {isNotificationOpen && (
              <div className="dropdown-menu notification-dropdown show">
                <div className="dropdown-header d-flex justify-content-between align-items-center">
                  <h6 className="mb-0">Notifications</h6>
                  <span className="text-primary small cursor-pointer">Mark all as read</span>
                </div>
                <div className="dropdown-divider"></div>
                <div className="notification-list">
                  {notifications.length > 0 ? (
                    notifications.map((notif) => (
                      <div key={notif.id} className={`dropdown-item notification-item ${!notif.read ? 'unread' : ''}`}>
                        <div className="d-flex flex-column">
                          <span className="notification-message">{notif.message}</span>
                          <span className="notification-time">{notif.time}</span>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="dropdown-item text-center text-muted">
                      No notifications
                    </div>
                  )}
                </div>
                <div className="dropdown-divider"></div>
                <div className="dropdown-footer text-center">
                  <span className="text-primary small cursor-pointer">View all notifications</span>
                </div>
              </div>
            )}
          </div>

          {/* Profile Dropdown */}
          <div className="profile position-relative">
            <div
              className="d-flex align-items-center gap-2 cursor-pointer profile-trigger"
              onClick={() => setIsProfileOpen(!isProfileOpen)}
              style={{ cursor: 'pointer' }}
            >
              <div className="profileimage">
                <img
                  src={`${process.env.PUBLIC_URL}/assets/images/avatar-1.jpg`}
                  alt="Avatar"
                />
              </div>
              <div className="name fw-semibold lh-1">
                {admin?.name || 'Admin'}
                <span className="op-7 pt-1 fw-normal d-block fs-12">
                  {admin?.role || 'Administrator'}
                </span>
              </div>
              <IoIosArrowDown className={`arrow-icon ${isProfileOpen ? 'rotated' : ''}`} />
            </div>

            {isProfileOpen && (
              <div className="dropdown-menu profile-dropdown show">
                <div className="dropdown-header profile-header">
                  <div className="d-flex align-items-center gap-3">
                    <img
                      src={`${process.env.PUBLIC_URL}/assets/images/avatar-1.jpg`}
                      alt="Avatar"
                      className="profile-dropdown-image"
                    />
                    <div>
                      <h6 className="mb-0">{admin?.name || 'Admin'}</h6>
                      <small className="text-muted">{admin?.email || 'admin@example.com'}</small>
                    </div>
                  </div>
                </div>
                <div className="dropdown-divider"></div>

                <div className="dropdown-item" onClick={() => handleProfileClick('/profile')}>
                  <IoIosPerson size={18} className="me-2" />
                  My Profile
                </div>

                <div className="dropdown-item" onClick={() => handleProfileClick('/change-password')}>
                  <IoIosKey size={18} className="me-2" />
                  Change Password
                </div>

                <div className="dropdown-divider"></div>

                <div className="dropdown-item text-danger" onClick={handleLogout}>
                  <IoIosLogOut size={18} className="me-2" />
                  Logout
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Header;